import { useContext } from 'react';
import { UserContext } from '../../contexts/user-context';
import { useVenturesContext } from '../../contexts/ventures-context';
import { Dialog } from '../common';
import AssignVenturesForm from '../forms/assign-ventures';

function MentorAssignmentModal() {
  const { hasAccessToAction } = useContext(UserContext);
  const {
    mentorsAssignmentTargetVenture,
    isMentorsAssigningVenture,
    loadedMentorsById,
    handleMentorsLoaded,
    assignMentorsSuccessForm,
    setMentorsAssignmentTargetVenture,
  } = useVenturesContext();

  return hasAccessToAction('venture.details.update') &&
    mentorsAssignmentTargetVenture ? (
    <Dialog
      title='New assignment'
      caption={`${mentorsAssignmentTargetVenture.ventureName}`}
      contentRenderer={({ handleClose }) => (
        <AssignVenturesForm
          ventureId={mentorsAssignmentTargetVenture.id}
          loading={isMentorsAssigningVenture[mentorsAssignmentTargetVenture.id]}
          onLoaded={handleMentorsLoaded(mentorsAssignmentTargetVenture.id)}
          mentors={loadedMentorsById[mentorsAssignmentTargetVenture.id]}
          onSuccess={assignMentorsSuccessForm(
            mentorsAssignmentTargetVenture.id,
            handleClose,
          )}
          onCancel={handleClose}
        />
      )}
      open={!!mentorsAssignmentTargetVenture}
      setOpen={(open) =>
        setMentorsAssignmentTargetVenture((prev) => (open ? prev : null))
      }
      width={720}
    />
  ) : null;
}

export default MentorAssignmentModal;
